module.exports = {
    apiUrl: 'http://localhost:3000/api'
}